import React from 'react';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="dark-header">
        <Link to="/" className="dark-logo-text">NIRAIE</Link>
        <nav className="dark-nav">
          <a href="/#features" className="dark-nav-link">Features</a>
          <a href="/#pricing" className="dark-nav-link">Pricing</a>
          <a href="/#faq" className="dark-nav-link">FAQ</a>
          <Link to="/contact" className="dark-nav-link">Contact</Link>
          <button className="btn-primary">Get Started</button>
        </nav>
      </header>

      {/* Policy Hero */}
      <section className="policy-hero">
        <div className="policy-hero-content">
          <h1 className="page-title">Refund Policy</h1>
          <p className="page-subtitle">Last updated: December 13, 2024</p>
        </div>
      </section>

      {/* Policy Content */}
      <section className="policy-section">
        <div className="policy-container">
          <div className="policy-content">
            <h2 className="policy-heading">1. Overview</h2>
            <p className="policy-text">
              At Niraie, we strive to provide exceptional service through our AI Tax Chat Engine. This Refund Policy 
              outlines the circumstances under which refunds may be issued for our premium subscription service.
            </p>

            <h2 className="policy-heading">2. Free Trial</h2>
            <p className="policy-text">
              Our free tier allows you to ask 3 questions without any payment or credit card requirement. Since this 
              service is completely free, no refunds are applicable for the free tier.
            </p>

            <h2 className="policy-heading">3. Premium Subscription Refund Policy</h2>
            <p className="policy-text">
              For our premium subscription (₹200/month including all taxes), we offer the following refund terms:
            </p>

            <h3 className="policy-subheading">3.1 7-Day Money-Back Guarantee</h3>
            <p className="policy-text">
              If you are not satisfied with our premium service, you may request a full refund within the first 7 days 
              of your initial subscription. This guarantee applies only to your first subscription and not to renewal payments.
            </p>

            <h3 className="policy-subheading">3.2 Service Issues</h3>
            <p className="policy-text">
              If you experience technical issues that prevent you from using the service, and we are unable to resolve 
              them within 48 hours, you may be eligible for a prorated refund for the affected period.
            </p>

            <h3 className="policy-subheading">3.3 Billing Errors</h3>
            <p className="policy-text">
              If you were charged incorrectly due to a system error, we will issue a full refund for the incorrect charge 
              immediately upon verification.
            </p>

            <h2 className="policy-heading">4. Non-Refundable Situations</h2>
            <p className="policy-text">
              Refunds will NOT be issued in the following circumstances:
            </p>
            <ul className="policy-list">
              <li>After the 7-day money-back guarantee period has expired</li>
              <li>For subscription renewal charges (unless covered by exceptions below)</li>
              <li>If your account has been terminated due to violation of our Terms and Conditions</li>
              <li>For partial month usage after cancellation</li>
              <li>If you simply change your mind after the 7-day period</li>
              <li>For quality of AI responses that you find unsatisfactory (after the 7-day period)</li>
            </ul>

            <h2 className="policy-heading">5. How to Request a Refund</h2>
            <p className="policy-text">
              To request a refund, please follow these steps:
            </p>
            <ul className="policy-list">
              <li>Contact our support team at refunds@niraie.com</li>
              <li>Include your account email and subscription details</li>
              <li>Clearly state the reason for your refund request</li>
              <li>Provide any relevant documentation (for technical issues or billing errors)</li>
            </ul>
            <p className="policy-text">
              We will review your request within 3-5 business days and notify you of the outcome.
            </p>

            <h2 className="policy-heading">6. Refund Processing Time</h2>
            <p className="policy-text">
              Once your refund is approved:
            </p>
            <ul className="policy-list">
              <li>The refund will be processed within 5-7 business days</li>
              <li>Funds will be returned to your original payment method</li>
              <li>Depending on your bank or payment provider, it may take an additional 5-10 business days for the refund to appear in your account</li>
              <li>You will receive an email confirmation once the refund is processed</li>
            </ul>

            <h2 className="policy-heading">7. Subscription Cancellation</h2>
            <p className="policy-text">
              You can cancel your subscription at any time:
            </p>
            <ul className="policy-list">
              <li>Cancellation can be done through your account settings or by contacting support</li>
              <li>Your service will continue until the end of the current billing period</li>
              <li>No charges will occur after the current period ends</li>
              <li>No refunds are provided for the remaining days of the current billing period</li>
            </ul>

            <h2 className="policy-heading">8. Special Circumstances</h2>
            <p className="policy-text">
              We understand that exceptional circumstances may arise. If you believe you qualify for a refund outside 
              of our standard policy, please contact our support team. We will review your case on an individual basis 
              and make a fair determination.
            </p>

            <h2 className="policy-heading">9. Changes to Refund Policy</h2>
            <p className="policy-text">
              We reserve the right to modify this Refund Policy at any time. Changes will be posted on this page with 
              an updated "Last updated" date. Your continued use of the service after such changes constitutes acceptance 
              of the modified policy. However, any changes will not affect refund requests made before the policy update.
            </p>

            <h2 className="policy-heading">10. Dispute Resolution</h2>
            <p className="policy-text">
              If you are not satisfied with our refund decision, you may:
            </p>
            <ul className="policy-list">
              <li>Request a review by escalating to our management team at disputes@niraie.com</li>
              <li>We will respond within 7 business days with a final decision</li>
              <li>If still unresolved, you may seek resolution through appropriate legal channels</li>
            </ul>

            <h2 className="policy-heading">11. Contact Information</h2>
            <p className="policy-text">
              For refund requests or questions about this policy, please contact:
            </p>
            <p className="policy-text">
              <strong>Email:</strong> niraiethechatengine@gmail.com<br />
              <strong>Phone:</strong> +91 93859 32082<br />
              <strong>Address:</strong> 97G/10/1 Teachers Colony, 5th Street West, Tuticorin-628008
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="dark-footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">NIRAIE</div>
            <p className="footer-tagline">AI-Powered Tax Intelligence for Everyone</p>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><a href="/#features">Features</a></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#">Help Center</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Niraie. All rights reserved.</p>
        </div>
      </footer>

      {/* Custom Credit Badge */}
      <div className="custom-credit">
        <span>Made with</span>
        <a href="https://sukraconsolv.com" target="_blank" rel="noopener noreferrer" className="custom-credit-link">
          SUKRA CONSOLV
        </a>
      </div>
    </div>
  );
};

export default RefundPolicy;
